$(document).ready(function(){ 
  
	$('#faq_collapse > ul > li ').click(function() {      
      $(this).children('p').toggleClass('active', 500, "easeInOutQuint");			
		return false;
	});
  
    $('ul.menu-nav-mobile > li > h3').click(function() {
      var checkElement = $(this).next();

      $('ul.menu-nav-mobile li').removeClass('active');
      $(this).closest('li').addClass('active');	


      if((checkElement.is('ul')) && (checkElement.is(':visible'))) {
        checkElement.slideUp('normal');
      }

      if((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
        checkElement.slideDown('normal');
      }

      if (checkElement.is('ul')) {
        return false;
      } else {
        return true;	
      }		
    });
  
});
  